import { addDays, format, isSameDay, isToday } from 'date-fns';
import { useMemo } from 'react';
import BoldChevronLeftIcon from '~/components/icons/BoldChevronLeftIcon';
import BoldChevronRightIcon from '~/components/icons/BoldChevronRightIcon';
import HeadingPreviousNext from '~/components/forms/questions/scheduling/HeadingPreviousNext.jsx';
import { formatDate } from '~/lib/DateTime.js';
import DayHeading from '~/components/forms/questions/scheduling/DayHeading.jsx';

const DayNavigation = ({
    start,
    end,
    selectedDate,
    setSelectedDate,
    classes,
    onPrevious,
    onNext,
}) => {
    let allDates = useMemo(() => {
        let dates = [];
        let current = start;
        do {
            dates.push(current);
            current = addDays(current, 1);
        } while (current <= end);

        return dates;
    }, [start, end]);

    function hasClasses(date) {
        for (let c of classes) {
            if (isSameDay(new Date(c.start), date)) {
                return true;
            }
        }

        return false;
    }

    const canGoBack = start > new Date();

    return (
        <div>
            <HeadingPreviousNext
                className="mb-2"
                onPrevious={() => canGoBack && onPrevious()}
                onNext={onNext}
                start={start}
                end={end}
            />
            <div className="flex items-center justify-between -mx-4 space-x-2 rounded-lg px-3">
                {allDates.map(d => (
                    <DayHeading
                        key={d.toString()}
                        isSelected={selectedDate && isSameDay(selectedDate, d)}
                        date={d}
                        onClick={() => setSelectedDate(d)}
                        isDisabled={!hasClasses(d)}
                    />
                ))}
            </div>
        </div>
    );
};

export default DayNavigation;
